import * as yup from "yup";

export const scheduleDemoValidator = yup.object().shape({
  full_name: yup
    .string()
    .required("Full Name is required")
    .min(1),
  company_name: yup
    .string()
    .required("Company Name is required")
    .min(1),
  company_email: yup
    .string()
    .required("Company Email is required")
    .min(1),
  budget: yup
    .number()
    .required("Budget is required")
    .min(1),
});

export const applyToJoinValidator = yup.object().shape({
  name: yup
    .string()
    .required()
    .min(1),
  handle: yup
    .string()
    .required()
    .min(1),
  email: yup
    .string()
    .required()
    .min(1),
  worked_with: yup
    .string()
    .required()
    .min(1),
});

export const sendMeGuideValidator = yup.object().shape({
  email: yup
    .string()
    .required()
    .min(1)
    .email(),
});
